import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { FileModel } from '../../../models';

export type PreviewProcessorKind = 'url-streaming' | 'blob-fetch';

/** What the Apryse renderer hands to `UI.loadDocument`: a streamable URL or disk-backed bytes. */
export type PreviewSource = { kind: 'url'; url: string } | { kind: 'blob'; blob: Blob };

export type PreviewSourceEvent =
  | { type: 'progress'; loadedBytes: number; totalBytes: number | null }
  | { type: 'ready'; source: PreviewSource; cacheHit: boolean };

/**
 * Strategy for turning a file into something the viewer can load. Selected per file by
 * {@link FilePreviewProcessorFactory} — registration order on {@link FILE_PREVIEW_PROCESSORS}
 * is the priority order, and later entries double as runtime fallbacks for earlier ones.
 */
export interface FilePreviewProcessor {
  readonly kind: PreviewProcessorKind;

  supports(file: Partial<FileModel>): boolean;

  /** Resolves the viewer source, emitting download progress along the way when the strategy has any. */
  resolveSource(file: Partial<FileModel>): Observable<PreviewSourceEvent>;

  /** Backs the header Download button. */
  getDownloadBlob(file: Partial<FileModel>): Observable<Blob>;
}

export const FILE_PREVIEW_PROCESSORS = new InjectionToken<FilePreviewProcessor[]>('FILE_PREVIEW_PROCESSORS');
